import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedGridPattern } from '../../ui/animated-grid-pattern';
import { cn } from "../../../lib/utils";
import './IntroSectionCyberIncident.css';
import { FeaturesSectionWithHoverEffects } from '../../ui/feature-section-with-hoover-effect';
import CloudArchitectureImg from '../../../assets/images/logo-landing-itmonkeys-grey.png';
import { cyberIncidentFeatures } from '../../../data/features';
import { TextGradientScroll } from '../../ui/text-gradient-scroll';

const IntroSectionCyberIncident: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-cyber-incident">
      <div className="container-max-width tw-relative tw-flex tw-h-[500px] tw-w-full tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-border tw-bg-background tw-md:pt-20 tw-md:shadow-xl">
        <div className="centered-title-top">
          <h2>{t('incidentCyber.introSection.title', 'Solutions clé en main')}</h2>
          <h3 className='infra-title-subtitle'>{t('incidentCyber.introSection.subtitle1')}</h3>
          <h3 className='infra-title-subtitle'>{t('incidentCyber.introSection.subtitle2')}</h3>
          <div className="title-image-container">
            <img src={CloudArchitectureImg} alt="Architecture Cloud" className="title-below-image overflow-visible" />
          </div>
        </div>
        <AnimatedGridPattern
          numSquares={30}
          maxOpacity={0.1}
          duration={3}
          repeatDelay={1}
          className={cn(
            "[mask-image:radial-gradient(500px_circle_at_center,white,transparent)]",
            "tw-inset-x-0 tw-inset-y-[-30%] tw-h-[200%] tw-skew-y-12",
          )}
        />
      </div>

      <div className="tw-w-full tw-flex tw-flex-col tw-mt-8 tw-mt-[-8em] tw-mb-[2em]">
        <div className="tw-w-full tw-mt-[7em]">
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[47%_1fr] tw-gap-8 tw-items-center">
            {/* Gradient Column */}
            <div className="intro-gradient-column tw-relative tw-h-[31em] tw-flex tw-justify-center lg:tw-justify-start" style={{ borderTopLeftRadius: '100px' }}>
              <div
                aria-hidden="true"
                className="tw-absolute tw-inset-0 tw-pointer-events-none tw-z-0"
                style={{ borderTopLeftRadius: '100px' }}
              >
                <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-[#24bbd9]/20 tw-via-[#4166bc]/10 tw-to-transparent" style={{ borderTopLeftRadius: '100px' }} />
                <div className="tw-absolute -tw-top-10 -tw-left-10 tw-h-64 tw-w-64 tw-rounded-full tw-bg-[#24bbd9]/20 tw-blur-3xl tw-opacity-60" style={{ borderTopLeftRadius: '100px' }} />
              </div>
            </div>

            {/* Features Column */}
            <div>
              <div className="intro-text-2" style={{ maxWidth: '100%' }}>
                <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('incidentCyber.introSection.publicTarget', 'Idéal pour')}</h2>
                <h3 className="public-cible-description">{t('incidentCyber.introSection.targetAudience', 'Cette expertise s\'adresse aux entreprises exposées aux cybermenaces et nécessitant une réponse d\'urgence.')}</h3>
              </div>
              <FeaturesSectionWithHoverEffects
                limit={4}
                displayInRow={true}
                featuresData={cyberIncidentFeatures}
              />
            </div>
          </div>
        </div>
      </div>

    <div className="intro-section intro-challenges-section tw-w-full tw-relative tw-flex tw-items-center tw-pt-[1em] tw-overflow-hidden" style={{ borderBottomRightRadius: '100px' }}>
      <div
        aria-hidden="true"
        className="tw-absolute tw-inset-y-0 tw-left-1/2 tw-w-[50vw] tw-pointer-events-none tw-z-0"
      >
        <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-tl tw-from-[#24bbd9]/20 tw-via-[#4166bc]/10 tw-to-transparent" />
        <div className="tw-absolute -tw-bottom-10 -tw-right-10 tw-h-64 tw-w-64 tw-rounded-full tw-bg-[#24bbd9]/20 tw-blur-3xl tw-opacity-60" />
      </div>

      <div className="intro-row-1 tw-relative tw-overflow-hidden tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center">

        <div className="intro-text-1 intro-text-no-padding-top tw-relative tw-z-10 tw-pl-[70px]">
          <h2 style={{ marginBottom: '42px', maxWidth: '500px', fontSize: '62px' }}>
            {t('incidentCyber.clientProblems.title', 'Urgences Cyber')}
          </h2>
          <div className="tw-text-2xl md:tw-text-3xl tw-space-y-6">
          <div className="tw-block tw-pt-4">
            <TextGradientScroll text={t('incidentCyber.clientProblems.problems.ransomware', 'Attaques ransomware')} />
          </div>
          <div className="tw-block tw-pt-4">
            <TextGradientScroll text={t('incidentCyber.clientProblems.problems.intrusion', 'Intrusions réseau')} />
          </div>
          <div className="tw-block tw-pt-4">
            <TextGradientScroll text={t('incidentCyber.clientProblems.problems.dataLeak', 'Fuites de données')} />
          </div>
          <div className="tw-block tw-pt-4">
            <TextGradientScroll text={t('incidentCyber.clientProblems.problems.downtime', 'Arrêts de production')} />
          </div>
          <div className="tw-block tw-pt-4">
            <TextGradientScroll text={t('incidentCyber.clientProblems.problems.crisis', 'Gestion de crise')} />
          </div>
          </div>
        </div>

        {/* Right column image */}
        <div className="tw-hidden lg:tw-flex tw-justify-center tw-items-center tw-relative tw-z-10">
        </div>
      </div>
    </div>

    </div>
  );
};

export default IntroSectionCyberIncident;
